export default __webpack_public_path__ + "static/media/note-with-author.eb42a82c.png";